import { Box, Flex, Strong, Text } from "@radix-ui/themes";
import { ChatAvatar } from "./ChatAvatar";
import moment from "moment/moment";
import { IMessage } from "../../modals/ActivityModal/ActivityModal";
import { MessageAttachment } from "./MessageAttachment";

export function Message(props: { message: IMessage }) {
  return (
    <Flex gap={"3"} py={"4"}>
      <Box>
        <ChatAvatar branding={props.message.branding} />
      </Box>
      <Box>
        <Strong>{props.message.title}</Strong>{" "}
        <Text size={"1"}>
          {moment(props.message.created_at).format("MMM D • h:mm a")}
        </Text>
        {props.message.attachments.length > 0 &&
          props.message.attachments.map((attachment) => (
            <MessageAttachment key={attachment.url} attachment={attachment} />
          ))}
        <Text dangerouslySetInnerHTML={{ __html: props.message.content }} />
      </Box>
    </Flex>
  );
}
